import { Component } from '@angular/core';
import { ICON } from '@core/util/icon';
import {
	InterestRatePrimeOptions,
	InterestRateTypeOptions,
} from '@core/util/mortgage';
import {
	InterestRateType,
	MatterMortgage,
	MatterMortgagePriority,
} from '@models/mortgage';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import {
	MatterMortgageDispatch,
	MatterMortgagesState,
} from '@state/matter/matter_mortgages';
import { Observable } from 'rxjs';
import { TestHooks } from './aps-vtb-form.hooks';

@Component({
	selector: 'app-aps-vtb-form',
	templateUrl: './aps-vtb-form.component.html',
	standalone: false,
})
export class ApsVTBFormComponent {
	testHooks = TestHooks;
	@Select(MatterMortgagesState.getVTBMortgage)
	vtbMortgage$: Observable<MatterMortgage>;
	@SelectSnapshot(MatterMortgagesState.getVTBMortgage)
	vtbMortgage: MatterMortgage;
	public ICON = ICON;
	public interestRateTypeOptions = InterestRateTypeOptions;
	public interestRatePrimeOptions = InterestRatePrimeOptions;
	public variableRateType = InterestRateType.VARIABLE;
	constructor(private mortgageDispatch: MatterMortgageDispatch) {}

	setPriority(value: MatterMortgagePriority) {
		this.mortgageDispatch.updateMortgage(this.vtbMortgage.id, {
			priority: value,
		});
	}

	setAmount(value: number) {
		this.mortgageDispatch.updateMortgage(this.vtbMortgage.id, {
			amount: value,
		});
	}

	setMaturityDate(value: string) {
		this.mortgageDispatch.updateMortgage(this.vtbMortgage.id, {
			maturityDate: value,
		});
	}

	setTerm(value: string) {
		this.mortgageDispatch.updateMortgage(this.vtbMortgage.id, { term: value });
	}

	setInterestRateType(value: InterestRateType) {
		this.mortgageDispatch.updateMortgage(this.vtbMortgage.id, {
			interestRateType: value,
		});
	}

	setInterestRate(value: number) {
		this.mortgageDispatch.updateMortgage(this.vtbMortgage.id, {
			interestRate: value,
		});
	}

	setAbovePrime(value: boolean) {
		this.mortgageDispatch.updateMortgage(this.vtbMortgage.id, {
			interestAbovePrime: value,
		});
	}

	setPrimeInterestRate(value: number) {
		this.mortgageDispatch.updateMortgage(this.vtbMortgage.id, {
			primeInterestRate: value,
		});
	}

	setRegularPayments(value: number) {
		this.mortgageDispatch.updateMortgage(this.vtbMortgage.id, {
			regularPayments: value,
		});
	}

	setInterestOnlyPayments(value: boolean) {
		this.mortgageDispatch.updateMortgage(this.vtbMortgage.id, {
			interestOnlyPayments: value,
		});
	}
}
